import {OwnDisplayName} from './OwnDisplayName';
import './WorkspaceProfileMenu.css';

type Props={
  displayName:string;
  syntheticPreview?:boolean;
  onSyntheticRestart?:()=>void;
  onOwnDisplayNameSaved?:(name:string)=>void;
};

export function WorkspaceProfileMenu({displayName,syntheticPreview=false,onSyntheticRestart,onOwnDisplayNameSaved=()=>{}}:Props){
  if(syntheticPreview)return <div className="workspace-session">
    <div className="workspace-session-name"><span>Previewing as</span><OwnDisplayName name={displayName} editable={false} onSaved={onOwnDisplayNameSaved}/></div>
    {onSyntheticRestart?<button className="button-link" type="button" onClick={onSyntheticRestart}>Restart synthetic preview</button>:<span className="form-note">Preview session only</span>}
  </div>;
  return <details className="workspace-profile-menu">
    <summary aria-label={`Profile: ${displayName}`}>
      <span>Signed in as</span>
      <strong>{displayName}</strong>
    </summary>
    <div className="workspace-profile-menu__content">
      <div className="workspace-profile-menu__identity">
        <OwnDisplayName name={displayName} editable={!syntheticPreview} onSaved={onOwnDisplayNameSaved}/>
      </div>
      <a className="button-link" href="/sign-in">Switch user</a>
    </div>
  </details>;
}
